const events = [];

export function logAuthEvent(eventName, details = {}) {
  const entry = {
    eventName,
    correlationId: details.correlationId ?? null,
    user: details.user ?? null,
    timestamp: new Date().toISOString(),
    endpoint: details.endpoint ?? null,
    durationMs: details.durationMs ?? null,
    ...details
  };
  events.push(entry);
  return entry;
}

export function getAuthEventLog() {
  return [...events];
}

export function clearAuthEventLog() {
  events.length = 0;
}

export const AuthEventNames = {
  LOGIN_STARTED: 'LOGIN_STARTED',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILED: 'LOGIN_FAILED',
  TOKEN_REFRESH: 'TOKEN_REFRESH',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED',
  LOGOUT: 'LOGOUT',
  SESSION_RESTORED: 'SESSION_RESTORED',
  SESSION_TIMEOUT: 'SESSION_TIMEOUT',
  REQUEST_RETRY: 'REQUEST_RETRY'
};
